import { DatasetAccessLevel } from "datasets/types/enums/access-level";
import { format } from "date-fns";
import { EntityOverviewHeader } from "~/pages/manifold-nextgen/components/EntityOverviewHeader";
import { SectionHeading } from "~/pages/manifold-nextgen/components/SectionHeading";
import { AccessLevelBadge } from "~/pages/manifold-nextgen/components/datasets/AccessLevelBadge";
import { PersonalDatasetIcon } from "~/pages/manifold-nextgen/components/datasets/PersonalDatasetIcon";
import usePersonalDataset from "~/pages/manifold-nextgen/hooks/usePersonalDataset";

const PERSONAL_DATASET_NAME = "My Dataset";

export const PersonalDatasetOverview = () => {
  const { data: dataset } = usePersonalDataset();

  if (!dataset) {
    return null;
  }

  const createdAt = new Date(dataset.created_at);

  return (
    <div className="mx-auto w-full max-w-3xl pb-12 pt-4">
      <EntityOverviewHeader
        tiles={[]}
        icon={<PersonalDatasetIcon size={36} />}
        title={PERSONAL_DATASET_NAME}
        extra={
          <span>
            {"Personal dataset created on "}
            <time dateTime={createdAt.toISOString()} title={format(createdAt, "PPpp")}>
              {format(createdAt, "PP")}
            </time>
          </span>
        }
        roleBadge={<AccessLevelBadge accessLevel={DatasetAccessLevel.OWNER} />}
        isShared={false}
      >
        <div className="flex flex-col gap-3">
          <SectionHeading title="About" />
          <p className="max-w-2xl text-sm text-muted-foreground">
            A private space only you can see. Agents write draft tables and views into your
            Snowflake schema, and files into your S3 prefix — none of it is shared with anyone else
            until you promote a table into a dataset you own.
          </p>
        </div>
      </EntityOverviewHeader>
    </div>
  );
};
